import React, { useState } from 'react';
import { MdArrowBack, MdChevronRight, MdSwapHoriz, MdAccessTime } from 'react-icons/md';

const INTL_SERVICES = [
  { id: 'wire',   label: 'Wire Transfer',    sub: 'Domestic & international wires' },
  { id: 'swift',  label: 'SWIFT Payment',    sub: 'Global bank-to-bank transfers' },
  { id: 'draft',  label: 'Foreign Draft',    sub: 'Foreign currency bank drafts' },
];

const RATE_CAD_USD = 0.7312;

const CrossBorderScreen = ({ onNavigate, onBack }) => {
  const [fromCur, setFromCur]   = useState('CAD');
  const [toCur, setToCur]       = useState('USD');
  const [quoteAmount, setQuote] = useState('');
  const [converted, setConverted] = useState(null);

  const toCurrency = fromCur === 'CAD' ? 'USD' : 'CAD';
  const rate = fromCur === 'CAD' ? RATE_CAD_USD : 1 / RATE_CAD_USD;

  const handleSwap = () => {
    setFromCur(toCur);
    setToCur(fromCur);
    setConverted(null);
    setQuote('');
  };

  const handleGetQuote = () => {
    const amt = parseFloat(quoteAmount);
    if (!isNaN(amt) && amt > 0) setConverted((amt * rate).toFixed(2));
  };

  const fmt = (v, cur) => `${cur} $${parseFloat(v).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('home'))} aria-label="Back to home">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Cross-Border Banking</h1>
        </div>
      </header>

      <div className="scroll-content gray-bg">

        {/* Rate Banner */}
        <div className="cross-border-rate-banner">
          <div className="cross-border-rate-label">Live Exchange Rate</div>
          <div className="cross-border-rate-value">1 CAD = {RATE_CAD_USD} USD</div>
          <div className="cross-border-rate-time"><MdAccessTime size={11} style={{ marginRight: 3 }} />Updated today at 9:31 AM ET</div>
        </div>

        {/* Balance Cards */}
        <div className="cross-border-balances">
          <div className="cross-border-balance-card">
            <div className="cross-border-balance-cur">CAD</div>
            <div className="cross-border-balance-name">Chequing</div>
            <div className="cross-border-balance-amt">$4,231.50</div>
          </div>
          <div className="cross-border-balance-card">
            <div className="cross-border-balance-cur">USD</div>
            <div className="cross-border-balance-name">Chequing</div>
            <div className="cross-border-balance-amt">$1,240.00</div>
          </div>
        </div>

        {/* International Services */}
        <div className="cross-border-section-label">Send Money Internationally</div>
        <div className="emt-section" style={{ marginTop: 0 }}>
          {INTL_SERVICES.map(s => (
            <div key={s.id} className="cross-border-service-row">
              <div style={{ flex: 1 }}>
                <div className="cross-border-service-name">{s.label}</div>
                <div className="cross-border-service-sub">{s.sub}</div>
              </div>
              <span className="cross-border-soon-badge">Coming Soon</span>
              <MdChevronRight size={18} color="var(--text-light)" style={{ marginLeft: 6 }} />
            </div>
          ))}
        </div>

        {/* Currency Exchange */}
        <div className="cross-border-section-label">Currency Exchange</div>
        <div className="emt-section" style={{ marginTop: 0 }}>
          <div className="cross-border-swap-row">
            <div className="cross-border-cur-pill">{fromCur}</div>
            <button className="cross-border-swap-btn" onClick={handleSwap} aria-label="Swap currencies"><MdSwapHoriz size={20} /></button>
            <div className="cross-border-cur-pill">{toCurrency}</div>
          </div>
          <div className="emt-field" style={{ padding: '0 16px 12px' }}>
            <label className="emt-label">Amount ({fromCur})</label>
            <div className="emt-amount-wrapper">
              <span className="emt-currency-symbol">$</span>
              <input className="emt-amount-input" type="number" min="0" step="0.01" placeholder="0.00" value={quoteAmount} onChange={e => { setQuote(e.target.value); setConverted(null); }} />
              <span className="emt-currency-code">{fromCur}</span>
            </div>
          </div>
          {converted && (
            <div className="cross-border-quote-result">
              <span className="cross-border-quote-label">Estimated Amount</span>
              <span className="cross-border-quote-value">{fmt(converted, toCurrency)}</span>
              <span className="cross-border-quote-note">Rate: 1 {fromCur} = {rate.toFixed(4)} {toCurrency} · Indicative only</span>
            </div>
          )}
          <button className="emt-primary-btn" style={{ margin: '4px 16px 16px' }} onClick={handleGetQuote}>Get Quote</button>
        </div>

      </div>
    </div>
  );
};

export default CrossBorderScreen;
